import { render, staticRenderFns } from "./create-or-edit-app-base.vue?vue&type=template&id=62e96750&scoped=true"
import script from "./create-or-edit-app-base.vue?vue&type=script&lang=js"
export * from "./create-or-edit-app-base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e96750",
  null
  
)

export default component.exports